import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from '@app/auth.service';
import { CognitoAuthService } from '@app/cognito-auth.service';
import { AgilentOktaAuthService } from '@app/agilent-okta-auth.service';
import Utils from '@app/utils/utils';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private cognitoAuth: CognitoAuthService,
        private agilentOktaAuth: AgilentOktaAuthService
    ) {
        //
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Promise<boolean> {

        if (this.authService.isCognito()) {
            if (this.cognitoAuth.isAuthenticated()) {
                return true;
            }

            // Redirect to login page
            Utils.clearLocalStorage();
            this.cognitoAuth.setOriginalUrl(state.url);
            this.cognitoAuth.redirectToLoginPage();

            return false;
        }

        if (this.authService.isOkta()) {
            const canActivate = await this.agilentOktaAuth.authGuardCanActivate();
            return canActivate;
        }
    }

}
